module.exports = __webpack_public_path__ + "media/images/farey/index/dossier_de_reprise_de_cabinet_en_ligne-71797e10e3e06e87ccee55bc6080ff73.png";